import React from "react";

function SmartgateGlyph({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="smartgateInteriorAccent" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ffffff" stopOpacity="0.98" />
          <stop offset="1" stopColor="#dff6ea" stopOpacity="0.96" />
        </linearGradient>
      </defs>
      <path
        d="M20 26C20 18.82 25.82 13 33 13C40.18 13 46 18.82 46 26V47H20V26Z"
        fill="none"
        stroke="url(#smartgateInteriorAccent)"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 25.5H40"
        stroke="url(#smartgateInteriorAccent)"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M33 18V47"
        stroke="url(#smartgateInteriorAccent)"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle cx="33" cy="33" r="2.5" fill="#ffffff" />
      <path
        d="M15 18C18.3 13.6 24.8 10 33 10C40 10 45.9 12.6 49.5 16.7"
        fill="none"
        stroke="#dff6ea"
        strokeOpacity="0.78"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SmartgateGlyph;
